import { apiBaseUrl } from "../constants/constants";
export const apiUrl = `${apiBaseUrl.devServer}/api`;

//optional layer to add different environments of server
export const apiUrlPrefix = `${apiUrl}/v1`;
export const apiUrlPrefix2 = `${apiUrl}/v2`;
export const apiUrlPrefix3 = `${apiUrl}/v3`;

// Separate base for the options/dropdown APIs served from api-dev.lucimoments.com
const optionsApiUrlPrefix = `${apiBaseUrl.optionsServer}/api/v1`;

//main objects for different api urls
export const apiConstant = {
    testApi: apiUrl + "/getvimeo",
    session: {
        checkSessionValidity: apiUrlPrefix + "/sessions/check_session"
    },
    user: {
        checkEmail: apiUrlPrefix + "/sessions/check_email",
        signin: apiUrlPrefix + "/sessions/sign_in",
        checkInvitation: apiUrlPrefix + "/sessions/check_invitation",
        // forgotPassword: apiUrlPrefix + "/sessions/forgot_password_mail",
        forgotPasswordMail: apiUrlPrefix + "/sessions/forgot_password_mail",
        checkVerificationTokenValidity: apiUrlPrefix + "/sessions/check_token_validity",
        // verifyUserMail: apiUrlPrefix + "/sessions/verify_token",
        verifyUserMailToken: apiUrlPrefix + "/sessions/verify_token",
        forgotPassword: apiUrlPrefix + "/sessions/forgot_password_mail",
        resetPassword: apiUrlPrefix + "/sessions/forgot_password",
        changePassword: apiUrlPrefix + "/sessions/change_password",
        resendLink: apiUrlPrefix + "/sessions/resend_link",
        deleteUser: apiUrlPrefix2 + "/users", 
        signup: apiUrlPrefix + "/sign_up",
        verifyAppleUser: apiUrlPrefix2 + "/users/verify_user",
        appleSign: apiUrlPrefix2 + "/users",
        memberInvitation: apiUrlPrefix2 + "/users/member_invitation",
        userRole: apiUrlPrefix2 + "/users/user_role",
        approveUser: apiUrlPrefix + "/approve_user"
    },
    ///////////////////////////////////////////////pharoah apis start//////////////////////////
    userManagement: {
        viewMember: apiUrlPrefix + "/user_managements/view_members",
        addMember: apiUrlPrefix + "/user_managements/add_member",
        updateMemberRole: apiUrlPrefix + "/user_managements/update_role",
        acceptMemberInvitation: apiUrlPrefix + "/user_managements/accept_invitation",
        removeMember: apiUrlPrefix + "/user_managements/remove_member",
        resendMemberInvitation: apiUrlPrefix + "/user_managements/resend_invitation",
        userPermissionList: apiUrlPrefix + "/user_managements/user_role",
        unverifiedUsers : apiUrlPrefix + "/user_managements/unverified_users",
        resendVerificationLink: apiUrlPrefix + "/user_managements/resend_link",
        unapprovedUsers : apiUrlPrefix + "/user_managements/unapproved_users",
        approveUser: apiUrlPrefix + "/user_managements/approve_user",
        toggleAssignmentAvailability: apiUrlPrefix + "/user_managements/toggle_assignment_availability"
    },
    productAccess: {
        searchUsers: apiUrlPrefix + "/product_accesses/search_users",
        userAccess: apiUrlPrefix + "/product_accesses/user_access",
        updateAccess: apiUrlPrefix + "/product_accesses/update_access"
    },
    quickTurn: {
        quickTurns: apiUrlPrefix + "/quick_turns",
        acceptQuickTurn: apiUrlPrefix + "/quick_turns/accept",
        rejectQuickTurn: apiUrlPrefix + "/quick_turns/reject"
    },
        ///////////////////////////////////////////////pharoah apis end//////////////////////////

    

    event: {
        //////////////////pharoah apis start///////////////////////////////////////////
        projectList: apiUrlPrefix + "/events",
        viewProjectMembers: apiUrlPrefix + "/events/view_members",
        assignProjectMember: apiUrlPrefix + "/events/assign_member",
        changeProjectMemberRole: apiUrlPrefix + "/events/update_role",
        deleteProjectMember: apiUrlPrefix + "/events/remove_member",
        projectDetails: apiUrlPrefix + "/events",
        createEditingCycles: apiUrlPrefix + "/events/create_editing_cycle",
        brandboxAssets: apiUrlPrefix + "/events/brand_box",
        boardSummary: apiUrlPrefix + "/events/board_summary",
        boardColumn: apiUrlPrefix + "/events/board_column",
        updateDueDate: apiUrlPrefix + "/events/update_due_date",
        toggleHiddenOnPharoah: apiUrlPrefix + "/events/toggle_pharoah_visibility",
        hiddenEvents: apiUrlPrefix + "/events/hidden",
        //////////////////pharoah apis end///////////////////////////////////////////
        // //////////////////////////////////////////////remove apis below this////////////////////////////////////////////////
        create : apiUrlPrefix2 + "/events",
        cancelEvent: apiUrlPrefix + "/events/cancel",
        uploadVideo: apiUrlPrefix + "/upload",
        uploadList: apiUrlPrefix + "/media_files",
        addEvent: apiUrlPrefix2 + "/events/add_collab_event",
        downloadMedia: apiUrlPrefix + "/media_files/download",
        favoriteMedia: apiUrlPrefix + "/media_files/favourite",  
        guestEvent: apiUrlPrefix2 + "/events/guest_detail",
        acceptFinalVideo: apiUrlPrefix2 + "/events/accept_final_video",
        uploadListToLinkEvent: apiUrlPrefix + "/media_files/event_files",
        importFiles: apiUrlPrefix + "/media_files/import_file", 
        allMediaFiles: apiUrlPrefix + "/media_files/show_all",
        markViewed: apiUrlPrefix + "/media_files/view",
        createZippedMedia: apiUrlPrefix + "/media_files/create_zipped_media",
        downloadZippedMedia: apiUrlPrefix + "/media_files/show_zipped_media",
        viewProjectMember: apiUrlPrefix2 + "/events/view_member",
        addProjectMember: apiUrlPrefix2 + "/events/add_member",
        updateProjectMemberRole: apiUrlPrefix2 + "/events/update_role",
        changeProjectAdmin: apiUrlPrefix2 + "/events/change_admin",
        removeProjectAdmin: apiUrlPrefix2 + "/events/remove_admin",
        removeProjectMember: apiUrlPrefix2 + "/events/remove_member",
        myMediaFileProjects: apiUrlPrefix2 + "/events/zip_event_list",
        myMediaFilesOfProject: apiUrlPrefix + "/media_files/show_downloadable",
        editNotes:  apiUrlPrefix2 + "/events/edit_description",
    },

    options: {
        genre: apiUrlPrefix + "/options/genre",
        tone: apiUrlPrefix + "/options/tone",
        phoneCount: apiUrlPrefix + "/options/phone_count",
        qualityOption: apiUrlPrefix + "/options/quality_option",
        eventType: optionsApiUrlPrefix + "/options/event_type",
        videoLength: apiUrlPrefix + "/options/video_length",
        statusType: apiUrlPrefix + "/options/status_type",
        role:  apiUrlPrefix + "/options/role",
        asset:  apiUrlPrefix + "/options/label",
    },

    consents:{
        consentDetail: apiUrlPrefix2 + "/consents/upload_description",
        eventVideoUploadConsent: apiUrlPrefix2 + "/consents/event_file_upload"
    },

    revision:{
        ///////////////////pharoah api starts ////////////////////////////////
        manageInternalRevisions: apiUrlPrefix + "/internal_revisions",
        editingCycle: apiUrlPrefix + "/internal_revisions/editing_cycles",
        manageLogs: apiUrlPrefix + "/logs",
        rejectRevision: apiUrlPrefix + "/internal_revisions/reject_revision",
        acceptRevision: apiUrlPrefix + "/internal_revisions/accept_revision",
        //////////////////////pharoah api ends ////////////////////////////////
        videoUrl: apiUrlPrefix2 + "/revisions/final_video_url",
        checkNewVideo: apiUrlPrefix2 + "/revisions/check_new_final_video",
        createRevision: apiUrlPrefix2 + "/revisions",
        getRevisionLogs: apiUrlPrefix2 + "/logs",
       // createRevisionLogs: apiUrlPrefix2 + "/revisions/create_log",
        submitRevision: apiUrlPrefix2 + "/revisions/submit_revision",
        disableRevisionTutorial: apiUrlPrefix2 + "/revisions/revision_tutorial_flag"
    },

    organisation:{
        organisationList: apiUrlPrefix + "/organisations",
        // ///////////////remove apis below this //////////////////////////////////////////////////
        viewOrganisationMember: apiUrlPrefix3 + "/organisations/view_member",
        addOrganisationMember: apiUrlPrefix3 + "/organisations/add_member",
        updateOrganisationMemberRole: apiUrlPrefix3 + "/organisations/update_role",
        changeAdmin: apiUrlPrefix3 + "/organisations/change_admin",
        removeAdmin: apiUrlPrefix3 + "/organisations/remove_admin",
        removeOrganisationMember: apiUrlPrefix3 + "/organisations/remove_member",
        updateOrganisationName: apiUrlPrefix3 + "/organisations/update_name",
    },

    team:{
        createTeam: apiUrlPrefix3 + "/teams",
        updateTeamPrivacy: apiUrlPrefix3 + "/teams/update_scope",
        renameTeam: apiUrlPrefix3 + "/teams/rename",
        removeTeam: apiUrlPrefix3 + "/teams/delete",
        addTeamMember: apiUrlPrefix3 + "/teams/add_member",
        viewTeamMembers: apiUrlPrefix3 + "/teams/view_member",
        updateTeamMemberRole: apiUrlPrefix3 + "/teams/update_role",
        changeTeamAdmin: apiUrlPrefix3 + "/teams/change_admin",
        removeTeamAdmin: apiUrlPrefix3 + "/teams/remove_admin",
        removeTeamMember: apiUrlPrefix3 + "/teams/remove_member",
    },
    permission:{
        getPermission: apiUrlPrefix + "/permissions"
    },
    roles:{
        role: apiUrlPrefix + "/roles",
    },
    themes:{
        theme: apiUrlPrefix3 + "/themes",
        removeTheme: apiUrlPrefix3 + "/themes/set_deafult"
    },
    assets:{
        assetFile: apiUrlPrefix3 + "/assets",   
    },
    eventNotes:{
        manageEventNotes: apiUrlPrefix3 + "/event_notes"
    },
    guest:{
        registerGuestReviewer: apiUrlPrefix3 + "/guest_reviewers",
        eventDetails: apiUrlPrefix3 + "/guest_reviewers/event_detail",
        createLog: apiUrlPrefix2 + "/logs/create_guest_log"
    },
    client: {
        unverifiedUsers : apiUrlPrefix + "/user_managements/unverified_users",
        resendVerificationLink: apiUrlPrefix + "/user_managements/resend_link"
    }


};